// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EnvironmentFilledSvg from "@fishx/icons-svg/es/asn/EnvironmentFilled";
import FishxIcon from '../components/FishxIcon';

var EnvironmentFilled = function EnvironmentFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EnvironmentFilledSvg
  }));
};

EnvironmentFilled.displayName = 'EnvironmentFilled';
export default React.forwardRef(EnvironmentFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EnvironmentFilled.js
// module id = 2603
// module chunks = 0